export { MenuProvider, useMenuContext_unstable as useMenuContext } from '@fluentui/react-menu';
export type { MenuContextValue } from '@fluentui/react-menu';
